<template>
    <div>
        <div class="py-3 pl-3">
            {{ $t("account-page-visitor-payments.subtitle") }}
        </div>

        <b-alert v-if="alert.show" :variant="alert.variant" show>
            {{ alert.message }}
        </b-alert>

        <div class="row pl-3 my-3">
           <!-- filter for dates -->
            <div class="col-lg-6 col-md-6 col-xl-3">
                <div class="form-group row">
                    <label class="col-sm-3 col-md-4 col-lg-4 col-xl-4 col-form-label"> {{
                        $t("account-page-visitor-payments.date_from") }}</label>
                    <div class="col-sm-9 col-md-8 col-lg-8 col-xl-8">
                        <input v-model="filter.date_from" class="form-control" disabled type="date" />
                    </div>
                </div>
            </div>
            <div class="col-lg-6 col-md-6 col-xl-3">
                <div class="form-group row">
                    <label class="col-sm-3 col-md-4 col-lg-4 col-xl-4 col-form-label"> {{
                        $t("account-page-visitor-payments.date_to") }}</label>
                    <div class="col-sm-9 col-md-8 col-lg-8 col-xl-8">
                        <input v-model="filter.date_to" class="form-control" disabled type="date" />
                    </div>
                </div>
            </div>

            <!-- date dropdown -->
            <div class="col-lg-4 col-md-4 col-xl-2 py-sm-2 py-md-0 py-lg-0">
                <div class="dropdown w-100">
                    <a id="dateDropdown" :class="{ 'btn-warning': config.is_date_option_selected }"
                        aria-expanded="false" aria-haspopup="true" class="dropdown-toggle btn btn-block border"
                        data-toggle="dropdown" href="#" role="button">
                        {{ $t(date_filter[custom_filter.selected_date_option_key].language_key) }}
                    </a>
                    <div aria-labelledby="dateDropdown" class="dropdown-menu dropdown-menu-right">
                        <a v-for="(value, key) in date_filter" v-if="value.in_dropdown" class="dropdown-item w-100"
                            href="#" @click="select_date_option(value, key)">
                            {{ $t(value.language_key) }}
                        </a>
                    </div>
                </div>
            </div>

            <!-- payment and booking status dropdown -->
            <div class="col-lg-4 col-md-4 col-xl-2 py-sm-2 py-md-0 py-lg-0">
                <b-dropdown :variant="config.is_status_option_selected ? 'warning' : 'light'"
                    class="w-100 border rounded" menu-class="dropdown-menu-right dropdown-menu-arrow ">
                    <template #button-content>
                        {{ $t("account-page-visitor-payments.conditions") }}
                    </template>
                    <form class="filter-dropdown mw-14-rem" @submit.prevent>
                        <div class="container">
                            <span><i class="fas fa-filter" /> {{ $t("account-page-visitor-payments.search_filter")
                                }}</span>
                            <div class="dropdown-divider" />

                            <!-- Payment Status START -->
                            <template>
                                <span class="font-weight-bold"> {{ $t("account-page-visitor-payments.payment_statuses")
                                    }} </span>

                                <div v-for="(value, key) in payment_statuses" class="form-check">
                                    <input v-model="custom_filter.payment_statuses[value.code]" :false-value="false"
                                        :true-value="true" class="form-check-input" type="checkbox"
                                        @change="select_statuses($event, 'payment_statuses', value.code, value.ids)" />
                                    <label class="form-check-label">
                                        {{ $t(value.language_key) }}
                                    </label>
                                </div>
                            </template>
                            <div class="dropdown-divider" />

                            <!-- Booking status filter -->
                            <template>
                                <span class="font-weight-bold"> {{ $t("account-page-visitor-payments.booking_statuses")
                                    }}</span>

                                <div v-for="(value, key) in booking_statuses" class="form-check">
                                    <input v-model="custom_filter.booking_statuses[value.code]" :false-value="false"
                                        :true-value="true" class="form-check-input" type="checkbox"
                                        @change="select_statuses($event, 'booking_statuses', value.code, value.ids)" />
                                    <label class="form-check-label">
                                        {{ $t(value.language_key) }}
                                    </label>
                                </div>
                            </template>
                        </div>
                    </form>
                </b-dropdown>
            </div>

            <!-- clear filter -->
            <div class="col-lg-4 col-md-4 col-xl-2 py-sm-2 py-md-0 py-lg-0 d-sm-none d-md-block">
                <button :disabled="!(config.is_status_option_selected || config.is_date_option_selected)"
                    class="btn btn-primary btn-block" @click="clear_filter">
                    {{ $t("account-page-visitor-payments.clear_filter") }}
                </button>
            </div>
        </div>

        <div class="row pl-3 my-3 justify-content-between">
         <!-- filter for rsv -->
            <div class="col-lg-8 col-md-8 col-xl-6">
                <div class="form-group row">
                    <label class="col-sm-3 col-md-3 col-lg-3 col-xl-2 col-form-label"> {{
                        $t("account-page-visitor-payments.reservation") }}</label>
                    <div class="col-sm-9 col-md-9 col-lg-9 col-xl-10">
                        <input v-model="filter.reservation_number" class="form-control" type="text"
                            v-on:keyup.enter="search" />
                    </div>
                </div>
            </div>
            <!-- donwload button -->
            <div class="col-lg-4 col-md-4 col-xl-2 py-sm-2 py-md-0 py-lg-0 order-12">
                <button @click="download" class="btn btn-primary btn-block">
                    {{ $t("account-page-visitor-payments.download") }}
                </button>
            </div>

            <!-- clear filter -->
            <div class="col py-sm-2 d-sm-block d-md-none order-1">
                <button :disabled="!(config.is_status_option_selected || config.is_date_option_selected)"
                    class="btn btn-primary btn-block" @click="clear_filter">
                    {{ $t("account-page-visitor-payments.clear_filter") }}
                </button>
            </div>
        </div>
        <div class="row pl-3 my-3">
            <div class="col-lg-12 mb-4">{{ $t("account-page-visitor.timezone") }} ({{ facility.timezone ?
                facility.timezone.value : "Asia/Tokyo" }})</div>
            <div class="col-12">
                <div class="table-responsive table-bordered visitors-table">
                    <table id="dataTable" cellspacing="0" class="table table-bordered visitors-table mb-0" width="100%">
                        <thead>
                            <tr>
                                <th>{{ $t("account-page-visitor-payments.amount") }} JPY</th>
                                <th>{{ $t("account-page-visitor-payments.type") }}</th>
                                <th>{{ $t("account-page-visitor-payments.checkin_date") }}</th>
                                <th>{{ $t("account-page-visitor-payments.checkout_date") }}</th>
                                <th>{{ $t("account-page-visitor-payments.settlement_date") }}</th>
                                <th>{{ $t("account-page-visitor-payments.reservation") }}</th>
                                <th>{{ $t("account-page-visitor-payments.booking_status") }}</th>
                                <th>{{ $t("account-page-visitor-payments.payment_status") }}</th>
                                <th>{{ $t("account-page-visitor-payments.captured_date") }}</th>
                                <th>{{ $t("account-page-visitor-payments.refund_date") }}</th>
                                <th>{{ $t("account-page-visitor-payments.detail") }}</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(value, key) in data.data">
                                <td>{{ formatAmount(value.amount) }}</td>
                                <td>{{ value.entry_method }}</td>
                                <td>{{ formatDate(value.checkin_date) }}</td>
                                <td>{{ formatDate(value.checkout_date) }}</td>
                                <td>{{ formatUtcToFacilityTimezone(value.settlement_date) }}</td>
                                <td>{{ value.reservation_number }}</td>
                                <td>{{ $t(`booking_statuses.${value.booking_code}`) }}</td>
                                <td>{{ $t(`payment_statuses.${value.latest_status}`) }}</td>
                                <td>{{ value.captured_date ? formatUtcToFacilityTimezone(value.captured_date) : "--" }}</td>
                                <td>
                                    <div class="d-flex justify-content-between">
                                       <p>{{ value.refund_date ? formatUtcToFacilityTimezone(value.refund_date) : "--" }}</p>
                                       <div v-if="value.metadata != null">
                                          <b-badge
                                             pill
                                             v-b-tooltip.hover
                                             :title="getMetadataValue(value.metadata)"
                                             variant="success"
                                          >
                                             <i class="fas fa-info-circle" />
                                          </b-badge>

                                       </div>
                                    </div>
                                 </td>
                                <td>
                                    <a class="text-primary cursor-pointer btn" href="javascript:void(0)" role="button"
                                        @click="$refs.ArbitrageShow.view(value)">{{
                                            $t("account-page-visitor-payments.view") }}</a>
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <div class="row pl-3 my-3">
            <div class="col-8">
                <div class="float-left">
                    <!--                    v-model="visitor_paginate.page"-->
                    <pagination v-model="data.current_page" :options="{ theme: 'bootstrap4', texts: { count: '' } }"
                        :per-page="filter.per_page" :records="data.total" @paginate="paginate" />
                </div>
            </div>
            <div class="col-lg-4">
                <div class="form-row">
                    <div class="col-8">
                        <label class="float-right">
                            <span class="align-middle">
                                {{ $t("account-page-visitor-payments.show") }}
                            </span>
                        </label>
                    </div>
                    <div class="col-4">
                        <select v-model="filter.per_page" class="form-control" required @change="search()">
                            <option :value="10">10</option>
                            <option :value="25">25</option>
                            <option :value="50">50</option>
                            <option :value="100">100</option>
                            <option :value="250">250</option>
                            <option :value="500">500</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <b-modal id="date-filter-modal" centered hide-footer no-close-on-backdrop size="md">
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group row">
                        <label class="col-3 col-form-label"> {{ $t("account-page-visitor-payments.date_from") }}</label>
                        <div class="col-9">
                            <input v-model="custom_filter.date_from" class="form-control" type="date" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <div class="form-group row">
                        <label class="col-3 col-form-label"> {{ $t("account-page-visitor-payments.date_to") }}</label>
                        <div class="col-9">
                            <input v-model="custom_filter.date_to" class="form-control" type="date" />
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center">
                <b-button :disabled="!(custom_filter.date_to && custom_filter.date_from)" class="mt-4" pill size="lg"
                    variant="primary" @click="handle_custom_date">
                    {{ $t("account-page-visitor-payments.ok") }}
                </b-button>
            </div>
        </b-modal>
        <ArbitrageShow ref="ArbitrageShow" :facilityid="facility.id" @refresh-settlement="loadDataAgain"/>
    </div>
</template>

<script>

import formatters from '@/mixins/formatters.js';
import moment from "moment";
import {
    visitor_payments_arbitrage_payment_statuses_filter,
    visitor_payments_booking_statuses_filter,
    visitor_payments_date_filter
} from '@/modules/checkin-facility/utils/mockup';

import {
  main_form_methods,
} from "@/modules/checkin-facility/utils/mockup";

const  { formatUtcToFacilityTimezone } = main_form_methods;

import ArbitrageShow from "./arbitrageShow.vue";
import t from 'typy';

export default {
    components: { ArbitrageShow },
    name: "ArbitrageSettlement",
    data() {
        return {
            data: {
                data: [],
                current_page: 1,
                total: 0,
            },
            facility: window._app_facility,
            date_filter: visitor_payments_date_filter,
            payment_statuses: visitor_payments_arbitrage_payment_statuses_filter,
            booking_statuses: visitor_payments_booking_statuses_filter,
            config: {
                is_date_option_selected: false,
                is_status_option_selected: false,
                clear: false,
            },
            custom_filter: {
                payment_statuses: {},
                payment_statuses_values: [],
                booking_statuses: {},
                booking_statuses_values: [],
                deduct_number_of_days: 7,
                selected_date_option_key: 0,
                date_from: null,
                date_to: null,
            },
            filter: {
               reservation_number: null,
                date_to: null,
                date_from: null,
                per_page: 50,
                page: 1,
                timezone: '',
            },
            isArbitrageEnabled: false,
            alert: {
                show: false,
                variant: 'success',
                message: ''
            }
        };
    },
    async mounted() {
        await this.init_filter();
        const tz = window._app_facility?.timezone?.value;

        this.filter.timezone = tz ?? 'Asia/Tokyo';

        await this.list({ ...this.filter, page: 1 });
    },
    methods: {
        formatUtcToFacilityTimezone,
        async loadDataAgain() {
            await this.list({ ...this.filter, page: 1 });

             this.showAlert(
                "success", 
                this.$t("account-page-notif-control.schedule_pre_checkin_notice.success_msg")
            );
        },
        showAlert(variant, message) {
            this.alert = {
                show: true,
                variant,
                message,
            };

            setTimeout(() => {
                this.alert.show = false;
            }, 3000);
        },

        async list(data) {
            try {
                this.data = await this.$lionheart.get("/v2/settlement-list", { params: data }).then((success) => success.data.data);
            } catch (error) {
                this.data = { data: [], current_page: 1, total: 0 };

                this.showAlert(
                    "danger",
                    this.$t("account-page-notif-control.schedule_pre_checkin_notice.sms_pre_checkin_notice.sms_error_alert")
                );
            }
        },
        async paginate(page) {
            await this.list({ ...this.filter, page: page });
        },
        async search() {
            this.store_filter();
            await this.list(this.filter);
        },
        async init_filter() {
            this.filter.facility_id = this.facility.id;
            var filter = this.$storage.get(`visitor_payments_filter_${this.facility.id}`);
            if (filter) {
                Object.assign(this.$data, filter);
            } else {
                await this.populate_date(this.custom_filter.deduct_number_of_days);
            }
        },
        async download() {
            try {
                const response = await this.$lionheart.get("/v2/settlement-list", {
                    params: { ...this.filter, download: 1 },
                    responseType: "arraybuffer",
                });

                const file = moment().format("YYYYMMDD");
                const blob = new Blob([response.data], { type: "application/xls" });
                const link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.setAttribute("download", `${file}_payments.xlsx`);
                document.body.appendChild(link);
                link.click();
                link.remove();

                this.showAlert(
                    "success", 
                    this.$t("account-page-notif-control.schedule_pre_checkin_notice.success_msg")
                );
            } catch (error) {
                const message = this.$t("account-page-notif-control.schedule_pre_checkin_notice.sms_pre_checkin_notice.sms_error_alert");
                this.showAlert("danger", message);
            }
        },
        async store_filter() {
            this.$storage.set(`visitor_payments_filter_${this.facility.id}`, {
                filter: this.filter,
                config: this.config,
                custom_filter: this.custom_filter,
            });
        },
        async clear_filter() {
            this.config = {
                is_date_option_selected: false,
                is_status_option_selected: false,
                clear: false,
            };
            this.custom_filter = {
                payment_statuses: {},
                payment_statuses_values: [],
                booking_statuses: {},
                booking_statuses_values: [],
                latest_statuses_values: [],
                latest_statuses: {},
                deduct_number_of_days: 7,
                selected_date_option_key: 0,
            };
            this.filter = {
                date_to: null,
                date_from: null,
                per_page: 50,
                page: 1,
                facility_id: this.facility.id,
                timezone: moment.tz.guess(),
            };

            await this.store_filter();
            await this.list({ ...this.filter, page: 1 });
        },
        async populate_date(number_of_days) {
            var from = new Date();
            from.setDate(from.getDate() - number_of_days);
            this.filter.date_from = moment(from).format("YYYY-MM-DD");
            this.filter.date_to = moment(new Date()).format("YYYY-MM-DD");
        },
        async handle_custom_date() {
            this.filter.date_from = this.custom_filter.date_from;
            this.filter.date_to = this.custom_filter.date_to;
            this.$bvModal.hide("date-filter-modal");
            this.custom_filter.selected_date_option_key = this.custom_filter.is_custom_selected_date_option_key;
            this.config.is_date_option_selected = true;
            await this.store_filter();
            await this.list({ ...this.filter, page: 1 });
        },
        async select_date_option(data, key) {
            if (!data.modal) {
                this.custom_filter.selected_date_option_key = key;
                this.config.is_date_option_selected = true;
                this.custom_filter.deduct_number_of_days = data.number_of_days;
                await this.populate_date(this.custom_filter.deduct_number_of_days);
                await this.list({ ...this.filter, page: 1 });
            } else {
                this.custom_filter.is_custom_selected_date_option_key = key;
                this.$bvModal.show(data.target);
            }
            await this.store_filter();
        },
        async select_statuses($event, model, code, ids) {
            delete this.filter["booking_status_ids"];
            delete this.filter["latest_status"];
            this.config.is_status_option_selected = false;
            this.custom_filter[`${model}_values`] = this.custom_filter[`${model}_values`].filter((value, index) => !ids.includes(value));

            if (this.custom_filter[model][code]) {
                this.custom_filter[`${model}_values`] = [...this.custom_filter[`${model}_values`], ...ids];
            }
            if (this.custom_filter.payment_statuses_values.length) {
                this.config.is_status_option_selected = true;
                this.filter.latest_status = this.custom_filter.payment_statuses_values.toString();
            }

            if (this.custom_filter.booking_statuses_values.length) {
                this.config.is_status_option_selected = true;
                this.filter.booking_status_ids = this.custom_filter.booking_statuses_values.toString();
            }

            await this.store_filter();
            await this.list({ ...this.filter, page: 1 });
        },

        getMetadataValue(medata) {
         return JSON.parse(medata).reason
        }
    },
    mixins: [formatters],
};

</script>